import YesNoInputGroup from './YesNoInputGroup';
export default YesNoInputGroup;